const PAGE= {
    LOGIN: '/auth/login',
    FORGET_PASSWORD: '/auth/forgot-password',
    CONFIRM_PASSWORD: '/auth/reset-password',
    PASSWORD_CHANGED: '/auth/password-changed',
    EMAIL_CONFIRMATION: '/auth/email-confirmation',
    DASHBOARD: '/dashboard',
    MARGIN_STATEMENT: '/dashboard/margin-statement',
    OUTSTANDING_STATEMENT: '/dashboard/outstanding-statement',
    DAILY_BUSINESS_REPORT: '/dashboard/daily-business-done',
    STATEMENT_SUMMARY: '/dashboard/statement-summary',
    SET_OFF:"/dashboard/set-off",
    SET_OFF_HISTORY:"/dashboard/set-off/history",
    WITHDRAWAL:"/dashboard/withdraw",
    DEPOSIT:"/dashboard/payment-statement",
    PAYMENT_DETAIL:"/dashboard/payment/detail",
    FPX_TRANSFER:"/dashboard/payment/fpx-transfer",
    MANUAL_TRANSFER:"/dashboard/payment/manual-transfer",
    E_DEPOSIT: '/dashboard/e-deposit',
    DEPOSIT_TRANSACTION: '/dashboard/transaction-history',
    PAYMENT_HISTORY: '/dashboard/payment/history',
    WITHDRAW_TRANSACTION: '/dashboard/withdraw-history',
    REDIRECT_PAYMENT_SUCCESS: '/dashboard/payment-transaction-success',
    REDIRECT_PAYMENT_FAILED: '/dashboard/payment-transaction-failed',
    MARGIN_CALCULATOR: '/dashboard/margin-calculator',
    P_AND_L_CALCULATOR: '/dashboard/p-and-l-calculator',
    E_PAYMENT: '/dashboard/payment',
    USER_ACTIVATION: '/auth/user-activate',
    FAQ: '/static/help',
    SUCCESSFUL_ACTIVATE:"/auth/activate-successful",
    USER_GUIDE: "/dashboard/user-guide",
    SET_OFF_GUIDE: "/dashboard/user-guide/set-off-guide",
    PAYMENT_GUIDE: "/dashboard/user-guide/payment-guide",
    WITHDRAW_GUIDE: "/dashboard/user-guide/withdraw-guide",
    DEPOSIT_GUIDE: "/dashboard/user-guide/deposit-guide",
    ACTIVITY_LOG: "/dashboard/activity-log",
    PROFILE:"/dashboard/profile",
    EIPO:"/dashboard/e-ipo",
    EIPO_HISTORY:"/dashboard/e-ipo/history",
}

export default PAGE;
